enum errorTypes {
  REQUIRED = "REQUIRED",
  EMAIL = "EMAIL",
  TELEPHONE = "TELEPHONE",
  DATE = "DATE",
  DATE_OUT_OF_RANGE = "DATE_OUT_OF_RANGE",
  NUMBER_FORMAT = "NUMBER_FORMAT",
  NOT_IN_ENUMERATION = "NOT_IN_ENUMERATION",
  UNSUPPORTED_ASCII_ALPHABET_CHARSET = "UNSUPPORTED_ASCII_ALPHABET_CHARSET",
  UNSUPPORTED_ASCII_TEXT_CHARSET = "UNSUPPORTED_ASCII_TEXT_CHARSET",
  UNSUPPORTED_ALPHANUMERIC_CHARSET = "UNSUPPORTED_ALPHANUMERIC_CHARSET",
  UNSUPPORTED_POSTCODE_CHARSET = "UNSUPPORTED_POSTCODE_CHARSET",
  WRONG_FORMAT = "WRONG_FORMAT",
  MIN_LENGTH = "MIN_LENGTH",
  CONFIRMATION_CODE = "CONFIRMATION_CODE",
  NO_SPACE_AROUND = "NO_SPACE_AROUND",
  MATCHING_PASSWORD = "MATCHING_PASSWORD",
  PASSWORD_SHORT = "PASSWORD_SHORT",
  SEAT_DUPLICATE = "SEAT_DUPLICATE",
}

type keyTypes = keyof typeof errorTypes;

const ERRORS_LANG_DEFS: { [key in keyTypes]: string } = {
  REQUIRED: "Rules.required",
  EMAIL: "Rules.isEmail",
  TELEPHONE: "Rules.isPhoneNumber",
  DATE: "Rules.wrongFilledDate",
  DATE_OUT_OF_RANGE: "Rules.dateOutOfRange",
  NUMBER_FORMAT: "Rules.isNumeric",
  NOT_IN_ENUMERATION: "Rules.notInEnumeration",
  UNSUPPORTED_ASCII_ALPHABET_CHARSET: "Rules.unsupportedAsciiAlphabetCharset",
  UNSUPPORTED_ASCII_TEXT_CHARSET: "Rules.unsupportedAsciiTextCharset",
  UNSUPPORTED_ALPHANUMERIC_CHARSET: "Rules.unsupportedAlphanumericCharset",
  UNSUPPORTED_POSTCODE_CHARSET: "Rules.unsupportedPostcodeCharset",
  WRONG_FORMAT: "Rules.wrongFormat",
  MIN_LENGTH: "Rules.minLength",
  CONFIRMATION_CODE: "Rules.confirmationCode",
  NO_SPACE_AROUND: "Rules.noSpacesAround",
  MATCHING_PASSWORD: "Rules.matchingPassword",
  PASSWORD_SHORT: "Rules.passwordShort",
  SEAT_DUPLICATE: "Rules.seatDuplicate",
};

export { errorTypes, ERRORS_LANG_DEFS, keyTypes };
